import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Shape as ActionsShape } from 'lib/actions';
import { hasSurveyBlockType } from 'lib/block';
import { update } from 'entities/step-children/actions';
import { selectStepChild } from 'entities/step-children/reducer';
import { ContentShape } from 'entities/step-children/shape';
import { selectSelected } from 'entities/selected/reducer';
import {
  Actions,
  actionContexts,
  actionsMapper,
} from 'components/SideBarSettings/Shared/Actions';

export function ContentActions({
  blockId,
  selectedStepChild,
  actions,
  context,
  content,
  onUpdate,
}) {
  const prevActions = actions?.[blockId] ?? [];
  const hasSurveyBlock = hasSurveyBlockType(content);

  const handleActionsUpdate = newActions => {
    onUpdate(selectedStepChild, {
      actions: {
        ...actions,
        [blockId]: actionsMapper({
          prevActions,
          newActions,
          hasSurveyBlock,
        }),
      },
    });
  };

  return (
    <Actions
      actions={prevActions}
      context={context}
      hasSurveyBlock={hasSurveyBlock}
      onActionsChange={handleActionsUpdate}
    />
  );
}

ContentActions.propTypes = {
  blockId: PropTypes.string,
  selectedStepChild: PropTypes.string,
  actions: ActionsShape,
  context: PropTypes.oneOf(actionContexts),
  content: ContentShape,
  onUpdate: PropTypes.func,
};

const mapStateToProps = state => {
  const { stepChild: selectedStepChild } = selectSelected(state) ?? {};
  const { actions, content } = selectStepChild(state, selectedStepChild) ?? {};

  return {
    selectedStepChild,
    actions,
    content,
  };
};

const mapDispatchToProps = {
  onUpdate: update,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContentActions);
